import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { CalculationApiService } from "src/app/api/calculation-api.service";
import { CalculationRequest, CalculationResponse } from "src/app/model/calculation/trial-lens.model";
import { i18nService } from "src/app/service-utils/i18n.service";
import { NewOrderStoreService } from "../new-order-store-service.service";

@Injectable({
    providedIn: 'root'
  })
export class NewOrderTrialLensWithOverRefractionService {

    basic: number;

    constructor(private calculationApiService: CalculationApiService,
                private newOrderStoreService: NewOrderStoreService,
                private i18nService: i18nService) {
    }

    public async buildCalculationRequest(trialLensFirstSide: Array<any>, trialLensSecondForm?: Array<any>): Promise<CalculationResponse[]> {
        let trialLens: CalculationRequest[] = [];

        trialLens.push(this.buildCalculationSide(trialLensFirstSide));
        if(trialLensSecondForm) {
            trialLens.push(this.buildCalculationSide(trialLensSecondForm));
        }

        return Promise.resolve(await this.calculationApiService.calculateLens(trialLens).toPromise());
    }

    private buildCalculationSide(trialLensForm: Array<any>): CalculationRequest {
        let trialLensSide = new CalculationRequest();
        Object.keys(trialLensForm[0].controls).forEach(key => {
            if(trialLensForm[0].get(key).enabled) {
                if(key === 'backSide') {
                    trialLensSide.trialLens['backSideId'] = this.newOrderStoreService.getBackSides().find(backSide => backSide.name === trialLensForm[0].get(key).value).id;
                } else if (key === 'material') {
                    trialLensSide.trialLens['materialId'] = this.newOrderStoreService.getMaterials().find(material => material.name === trialLensForm[0].get(key).value).id;
                } else {
                    trialLensSide.trialLens.features[key.charAt(0).toUpperCase() + key.slice(1)] = this.i18nService.replaceFromCommaToDot(trialLensForm[0].get(key).value);
                }
            }
        });

        Object.keys(trialLensForm[1].controls).forEach(key => {
            if(trialLensForm[1].get(key).enabled)
                trialLensSide.overRefraction.features[key.charAt(0).toUpperCase() + key.slice(1)] = this.i18nService.replaceFromCommaToDot(trialLensForm[1].get(key).value);
        });

        Object.keys(trialLensForm[2].controls).forEach(key => {
            if(key === 'material') {
                trialLensSide.newParameter['materialId'] = this.newOrderStoreService.getMaterials().find(material => material.name === trialLensForm[2].get(key).value).id;
            } else {
                trialLensSide.newParameter.features[key.charAt(0).toUpperCase() + key.slice(1)] = this.i18nService.replaceFromCommaToDot(trialLensForm[2].get(key).value);
            }
        });
        
        if(trialLensForm[3]) {
            Object.keys(trialLensForm[3].featureValues).forEach(key => {
                if(key === 'PrismType') {
                    trialLensSide.trialLens.features['PrismType'] = trialLensForm[3].featureValues['PrismType'];
                } else if(key === 'Prism'){
                    trialLensSide.trialLens.features['Prism'] = this.i18nService.replaceFromCommaToDot(trialLensForm[3].featureValues['Prism']);
                } else if(key === 'Diameter'){
                    trialLensSide.trialLens.features['Diameter'] = this.i18nService.replaceFromCommaToDot(trialLensForm[3].featureValues['Diameter']);
                }
            });
        }

        return trialLensSide;
    }
}